// extracted by css-extract-rspack-plugin
export default {"variation":"a3c0pu46OAymLgtd","color":"crTRMeyVf4MamTxs","display":"lVnw4vnmIvZFjaFJ","allVariationsIcon":"wvAJjzz2xC8fldDN"};